
import React, { useState, useEffect } from "react";
import UserContextProvider, { ContextModel, User, EventData, OrderData, Config } from "../interface/interfaces";
import { sessionService } from "../service/sessionService";

interface Props {
    children: React.ReactNode;
}

const Context: React.FC<Props> = (props) => {
    const [user, setUser] = useState<User>(() => {
        const saved = sessionService.getCurrentUser();
        return saved || {
            id: 0,
            name: "",
            lastname: "",
            email: "",
            cards: [],
            dui: "",
            phone: "",
            photo: ""
        };
    });

    useEffect(() => {
        const handleAuthChange = () => {
            const saved = sessionService.getCurrentUser();
            if (saved) {
                setUser(saved);
            }
        };

        window.addEventListener("auth:changed", handleAuthChange);
        window.addEventListener("storage", handleAuthChange);

        return () => {
            window.removeEventListener("auth:changed", handleAuthChange);
            window.removeEventListener("storage", handleAuthChange);
        };
    }, []);

    const [event, setEvent] = useState<EventData>({});

    const [order, setOrder] = useState<OrderData>({});

    //Codigo de pais para obtener los eventos por pais
    const [config, setConfig] = useState<Config>({
        countryCode: "SV",
        storeKey: "404sZTz5riISt19BiShM",
        orderStoreKey: "SJ5b3V85JVtYZIfd8dvx"
        //gMeW62zhi8Q5soBXHG4K eventos raf
        //SJ5b3V85JVtYZIfd8dvx san benito
        // bIWIyB4Wo48E48QAxW3S zou
        // 404sZTz5riISt19BiShM eventos sv
    });


    const [events, setEvents] = useState<EventData[]>([]);

    const asignateEventData = (eventData: EventData) => {
        setEvent(eventData);
    };

    const asignateUser = (userData: User) => {
        setUser(userData);
    };

    const asignateOrderData = (orderData: OrderData) => {
        setOrder(orderData);
    };

    const asignateConfig = (configData: Config) => {
        setConfig(configData);
    }

    const asignateEventsArray = (eventsData: EventData[]) => {
        setEvents(eventsData);
    }

    const contextValue: ContextModel = {
        user,
        event,
        order,
        config,
        events,
        asignateEventsArray,
        asignateOrderData,
        asignateEventData,
        asignateUser,
        asignateConfig,
    };

    return (
        <UserContextProvider.Provider value={contextValue}>
            {props.children}
        </UserContextProvider.Provider>
    )
};

export default Context;